import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable, combineLatest, map } from 'rxjs';

import { shareLast, sortByStringProp } from '@dmb/core';

import { DmbClient, DmbLabel } from '../../model';
import { UserService } from '../../user';
import { CommsService } from '../comms';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private comms = inject(CommsService);
  private userService = inject(UserService);

  constructor() {
    // this handles broadcast events about the client tree
    // when the client hierarchy changes we need to send a ping
    // and the server will push the updates
    this.comms.onMessage('/client/events').subscribe(() => {
      this.comms.send('/client', 1);
    });
  }

  clients = this.comms.onMessage<Record<number, DmbClient>>('/user/client').pipe(shareLast());
  clientList = toSignal(this.clients.pipe(map((obj) => Object.values(obj))));

  client: Observable<DmbClient> = combineLatest([this.userService.authenticatedUser, this.clients]).pipe(
    map(([u, clients]) => clients[u.clientId]),
    shareLast(),
  );
  labels = this.comms.onMessage<DmbLabel[]>('/user/labels').pipe(
    map((l) => sortByStringProp(l, 'name')),
    shareLast(),
  );
}
